










































import Vue from "vue";
export default Vue.extend({
  name: "base-dropdown",
  props: {
    direction: {
      type: String,
      default: "down"
    },
    title: {
      type: String
    },
    icon: {
      type: String
    },
    position: {
      type: String
    },
    menuClasses: {
      type: [String, Object]
    },
    hideArrow: {
      type: Boolean
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    tag: {
      type: String,
      default: "li"
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    toggleDropDown() {
      this.isOpen = !this.isOpen;
      this.$emit("change", this.isOpen);
    },
    closeDropDown() {
      this.isOpen = false;
      this.$emit("change", this.isOpen);
    },
    calculatePosition() {
      const DOMRect = (this.$refs
        .trigger as HTMLElement).getBoundingClientRect();
      const height = DOMRect.height;
      const width = DOMRect.width;
      const top = DOMRect.top;
      const left = DOMRect.left;
      const y = height + top + 5;
      const x = width + left;
      return {
        x,
        y
      };
    },
    clickOutSide(e) {
      // console.log(e.target);
      if (
        !(
          this.$refs.dropdown === event.target ||
          (this.$refs.dropdown as HTMLElement).contains(e.target)
        )
      ) {
        this.closeDropDown();
      }
    }
  },
  watch: {
    isOpen() {
      if (this.appendToBody) {
        setTimeout(() => {
          const menu = this.$refs.menu as HTMLElement;
          if (this.isOpen) {
            const pos = this.calculatePosition();
            menu.style.display = "block";
            const menuRect = menu.getBoundingClientRect();
            // console.log(menuRect);
            menu.style.position = "absolute";
            menu.style.right = "auto";
            menu.style.top = `${pos.y + window.scrollY}px`;
            menu.style.left = `${pos.x - menuRect.width}px`;
            document.body.append(menu);
          }
        });
      }
    }
  },
  mounted() {
    window.addEventListener("click", this.clickOutSide, true);
  },
  destroyed() {
    window.removeEventListener("click", this.clickOutSide, true);
  }
});
